import React, { useState } from 'react';
import { NCZIExtension } from '../../../Interfaces/ncziTypes';
import { useLazyNcziExtensionItemQuery } from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';
import { NCZI_OID } from '../../../Enums/ncziOid.enum';
import Loading from '../../../../../Components/Loading';

interface Props {
	extension: NCZIExtension | null;
}

const NCZISetupExtensionValue: React.FC<Props> = props => {
	const { extension } = props;
	const [isReady, setIsReady] = useState<boolean>(false);
	const [extensionName, setExtensionName] = useState<string | null>(null);
	const [getExtensionItem] = useLazyNcziExtensionItemQuery();

	useEffectAsync(async () => {
		if (!extension?.scheme?.oid || !extension?.code) {
			setExtensionName('');
			setIsReady(true);
			return;
		}

		try {
			if (
				[
					NCZI_OID.MEDICAMENTS,
					'1.3.158.00165387.100.40.60',
					NCZI_OID.HEALTH_SERVICE_PROVIDER_OUPZS,
					'1.3.158.00165387.100.40.75',
					NCZI_OID.HEALTH_SERVICE_PROVIDER,
					NCZI_OID.HEALTH_PROFESSIONAL,
				].indexOf(extension.scheme.oid) !== -1
			) {
				const { item: extensionItem } = await getExtensionItem({
					oid: extension.scheme.oid,
					code: extension.code,
				}).unwrap();

				if (extensionItem) {
					setExtensionName(extensionItem.name);
				}
			} else {
				setExtensionName(extension.code);
			}
		} catch (e) {
			console.error(e);
		}

		setIsReady(true);
	});

	if (!isReady) {
		return <Loading />;
	}

	return <>{extensionName}</>;
};

export default NCZISetupExtensionValue;
